__turbopack_context__.v({
  "className": "crimson_text_970451f6-module__7StpwW__className",
});
